import styled from "styled-components";

export const ReportsWrapper = styled.div`
  margin-top: 3rem;
  width: 100%;
  display: flex;
  justify-content: center;
`;

export const StyledTableWrapper = styled.div`
  width: 100%;
`;

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  text-align: center;
  overflow: hidden;
  table-layout: fixed;
`;

export const HeaderCell = styled.th`
  padding: 16px;
  font-weight: bold;
  color: white;
  background-color: ${({ bg }) => bg || "gray"};
  font-family: AvenirLTProBlack, sans-serif;
  font-size: 1rem;
`;

export const StyledRow = styled.tr`
  height: 80px;
`;

export const ReportsButton = styled.button`
  background: transparent;
  border: 2px solid ${({ color }) => color || "#ccc"};
  color: ${({ color }) => color || "#333"};
  border-radius: 50%;
  width: 40px;
  height: 40px;
  font-size: 1.1rem;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;

  transition: all 0.2s ease;

  &:hover {
    background-color: ${({ color }) => color + "33"};
  }
`;
